'use client'

import getCategoryList from '@/app/[locale]/_service/category.service'
import { IRedux } from '@/app/[locale]/_store/types'
import { Box, Center, Text } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { useSelector } from 'react-redux'
import CategoryCard from './_components/CategoryCard'
import { useTranslations } from 'next-intl'
import Recommended from './_components/Recommended'
import recommendedService from '@/app/[locale]/_service/recommended.service'
import { Link } from '@/i18n/navigation'
import MenuLoading from '../loading'
import { useMenuContext } from '../../Products/utils/client'
import { useDynamicLanguage } from '@/app/[locale]/_hooks/useShipper'

const Landing = () => {
  const settings = useSelector((state: IRedux) => state.settings)
  const { useDynamicLanguage: dynamic, isShipperResolved } = useDynamicLanguage()

  const { platform_id, deliveryType, effectiveMenuId } = useMenuContext()

  const t = useTranslations()

  const { data: categories, isLoading } = useQuery({
    queryKey: ['categories', settings?.data?.shipper_id, deliveryType, effectiveMenuId, dynamic],
    queryFn: () =>
      getCategoryList(
        {
          page: 1,
          limit: 50,
          is_active: true,
          menu_id: effectiveMenuId,
          delivery_type: deliveryType,
          has_product: true,
        },
        settings?.data?.shipper_id,
        platform_id,
        dynamic
      ),
    enabled: Boolean(settings?.data?.shipper_id && effectiveMenuId) && isShipperResolved,
  })

  const { data: recommended } = useQuery({
    queryKey: ['recommended', settings?.data?.shipper_id, effectiveMenuId, deliveryType, dynamic],
    queryFn: () =>
      recommendedService.getAll(
        {
          page: 1,
          limit: 20,
          is_active: true,
          is_deleted: false,
          menu_id: effectiveMenuId,
          delivery_type: deliveryType,
          fields:
            'image,discounts,description,barcode,product_type,ikpu,package_code,tags,type,slug,has_modifier,weight,measurement,out_price',
          product_types: 'origin,simple,combo',
        },
        settings?.data?.shipper_id,
        platform_id,
        dynamic
      ),
    enabled: Boolean(settings?.data?.shipper_id && effectiveMenuId) && isShipperResolved,
  })

  return (
    <>
      <Center
        bg='primary'
        color='primary.text'
        flexDir={'column'}
        py={{ base: 5, lg: 8 }}
      >
        <Text pb={4} fontWeight={700} fontSize={{ base: 20, lg: 30 }}>
          {t('menu')}
        </Text>
        <Box w={'full'} className='menu_carousel'>
          {isLoading ? (
            <Box mb={5}>
              <MenuLoading />
            </Box>
          ) : (
            <CategoryCard categories={categories?.data?.categories || []} />
          )}
        </Box>
        <Link href={'/landing-menu'}>
          <Text borderBottom={'1px solid white'} fontWeight={500} fontSize={18}>
            {t('on_the_menu')}
          </Text>
        </Link>
      </Center>
      {recommended?.data?.recommended_products &&
        recommended?.data?.recommended_products?.length > 0 && (
          <Center
            flexDir={'column'}
            color={'text'}
            py={{ base: 5, lg: 8 }}
            bg={{ base: 'background.card', lg: 'background' }}
          >
            <Recommended recommended={recommended?.data} />
            <Link href={'/landing-menu'}>
              <Text
                borderBottom={'1px solid black'}
                fontWeight={500}
                fontSize={18}
              >
                {t('on_the_menu')}
              </Text>
            </Link>
          </Center>
        )}
    </>
  )
}

export default Landing
